import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import * as _ from "lodash";
import { of } from "rxjs";
import { catchError, map, switchMap,withLatestFrom } from "rxjs/operators";

import { VendorService } from "../../../services/api/vendor.service";
import { VendorActions } from "../../actions/vendor.actions";
import { FailState } from "../../models/fail-state";
import { StatState } from "../../models/stat-state";
import { AppState } from "../../reducers";
import { StatSelectors } from "../../selectors/stats.selectors";

@Injectable()
export class VendorStatsEffects {
	get = createEffect(() =>
		this.actions.pipe(
			ofType(VendorActions.stats.get),
			withLatestFrom(this.store.select(StatSelectors.stats)),
			switchMap(([, state]) =>
				this.canUseStoreValue(state)
					? of(VendorActions.stats.getSuccess({ ...state, loading: false }))
					: of(VendorActions.stats.getApi())
			)
		)
	);

	getApi = createEffect(() =>
		this.actions.pipe(
			ofType(VendorActions.stats.getApi),
			switchMap(() =>
				this.vendorService.stats().pipe(
					map((stats) => VendorActions.stats.getSuccess({ stats, loading: false })),
					catchError((error) => of(VendorActions.stats.getFail(new FailState(error))))
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private store: Store<AppState>,
		private vendorService: VendorService
	) {}

	canUseStoreValue(state: StatState): boolean {
		return !_.has(state, "error") && !state.loading;
	}
}
